import { api } from '../../api';
import { showErrorNotification, showSuccessNotification } from '../notifications/notifications';
import { fetchDriversAndTags, fetchUsers } from './fetchThunks';
import type { Driver } from '../../../types';
import type { ThunkDispatch } from 'redux-thunk';
import { ErrorOrigin, type ErrorResponse, getErrorCode } from '../../apiUtils';
import { saveDriverFailed, saveDriverInProgress, saveDriverSuccess } from '../drivers/sidebar/sidebarSlice';

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
export const saveDriver = (driverToSave: Driver) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch(saveDriverInProgress());

    return api
        .saveDriver(driverToSave)
        .then((response: Response) => {
            showSuccessNotification('intl-msg:save.success');
            dispatch(saveDriverSuccess(driverToSave));

            // fetch list of drivers again as the state may have changed
            dispatch(fetchUsers());
            dispatch(fetchDriversAndTags());

            return response;
        })
        .catch((errorResponse: ErrorResponse) => {
            showErrorNotification(getErrorCode(errorResponse, ErrorOrigin.DRIVER_ADMINISTRATION));
            dispatch(saveDriverFailed());
        });
};

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
export const saveDrivers = (driversToSave: Driver[]) => (dispatch: ThunkDispatch<any, any, any>) => {
    dispatch(saveDriverInProgress());

    return Promise.all(
        driversToSave.map(driverToSave => {
            return api
                .saveDriver(driverToSave)
                .then((response: Response) => {
                    showSuccessNotification('intl-msg:save.success');
                    dispatch(saveDriverSuccess(driverToSave));
                    return response;
                })
                .catch((errorResponse: ErrorResponse) => {
                    showErrorNotification(getErrorCode(errorResponse, ErrorOrigin.DRIVER_ADMINISTRATION));
                    dispatch(saveDriverFailed());
                });
        })
    ).then(() => {
        dispatch(fetchDriversAndTags());
        dispatch(fetchUsers());
    });
};
